"use strict";
/*
 * HSToggleCount
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var base_plugin_1 = __importDefault(require("../base-plugin"));
var HSToggleCount = /** @class */ (function (_super) {
    __extends(HSToggleCount, _super);
    function HSToggleCount(el, options) {
        var _this = _super.call(this, el, options) || this;
        var data = el.getAttribute('data-hs-toggle-count');
        var dataOptions = data ? JSON.parse(data) : {};
        var concatOptions = __assign(__assign({}, dataOptions), options);
        _this.target = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.target)
            ? typeof (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.target) === 'string'
                ? document.querySelector(concatOptions.target)
                : concatOptions.target
            : null;
        _this.min = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.min) || 0;
        _this.max = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.max) || 0;
        _this.duration = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.duration) || 700;
        _this.isChecked = _this.target.checked || false;
        if (_this.target)
            _this.init();
        return _this;
    }
    HSToggleCount.prototype.init = function () {
        var _this = this;
        this.createCollection(window.$hsToggleCountCollection, this);
        if (this.isChecked)
            this.el.innerText = String(this.max);
        this.target.addEventListener('change', function () {
            _this.isChecked = !_this.isChecked;
            _this.toggle();
        });
    };
    HSToggleCount.prototype.toggle = function () {
        if (this.isChecked)
            this.countUp();
        else
            this.countDown();
    };
    HSToggleCount.prototype.animate = function (from, to) {
        var _this = this;
        var startTimestamp = 0;
        var step = function (timestamp) {
            if (!startTimestamp)
                startTimestamp = timestamp;
            var progress = Math.min((timestamp - startTimestamp) / _this.duration, 1);
            _this.el.innerText = String(Math.floor(progress * (to - from) + from));
            if (progress < 1)
                window.requestAnimationFrame(step);
        };
        window.requestAnimationFrame(step);
    };
    // Public methods
    HSToggleCount.prototype.countUp = function () {
        this.animate(this.min, this.max);
    };
    HSToggleCount.prototype.countDown = function () {
        this.animate(this.max, this.min);
    };
    // Static methods
    HSToggleCount.getInstance = function (target, isInstance) {
        var elInCollection = window.$hsToggleCountCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection
            ? isInstance
                ? elInCollection
                : elInCollection.element
            : null;
    };
    HSToggleCount.autoInit = function () {
        if (!window.$hsToggleCountCollection)
            window.$hsToggleCountCollection = [];
        document
            .querySelectorAll('[data-hs-toggle-count]:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsToggleCountCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; }))
                new HSToggleCount(el);
        });
    };
    return HSToggleCount;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    HSToggleCount.autoInit();
    // Uncomment for debug
    // console.log('Toggle count collection:', window.$hsToggleCountCollection);
});
if (typeof window !== 'undefined') {
    window.HSToggleCount = HSToggleCount;
}
exports.default = HSToggleCount;
